import React from "react";
import styled from "styled-components";
const StyledCell = styled.td`
  &&& {
    width: 24px;
    min-width: auto;
  }
`;
const BulkSelectCell = ({ children = null }) => /* @__PURE__ */ React.createElement(StyledCell, { onClick: (event) => event.stopPropagation() }, children);
export default BulkSelectCell;
